/**
 * Generate all combinations of choosing k items from n items.
 * @param n - total number of items.
 * @param k - number of items to choose.
 * @returns array of combinations, where each combination is an array of indices.
 */
export function getCombinations(n, k) {
    if (k === 0)
        return [[]];
    if (k > n)
        return [];
    const results = [];
    const current = [];
    function backtrack(start) {
        if (current.length === k) {
            results.push([...current]);
            return;
        }
        for (let i = start; i < n; i++) {
            current.push(i);
            backtrack(i + 1);
            current.pop();
        }
    }
    backtrack(0);
    return results;
}
//# sourceMappingURL=getCombinations.js.map